export default __webpack_public_path__ + "static/media/card2.1ab03a18.wav";